
do () ->

    if not window["srm"]
        window["srm"] = {}

    if not window["srm"]["methodsMap"]
        window["srm"]["methodsMap"] = {}

    window['srm']["methodsMap"]["defaultName"] = 'Research Methods'
    window['srm']["methodsMap"]["defaultDefinition"] = 'Research methods are the systematic tools used to find, collect, analyze and interpret information.'
    window['srm']["methodsMap"]["duration"] = 750
    window['srm']["methodsMap"]["maxTextLength"] = 20
    window['srm']["methodsMap"]["maxMobileTextLength"] = 26
    window['srm']["methodsMap"]["urls"] = {
        'refCount': '/methodsmap/jsoncontentcounts?ref={ref}'
        'content': '/search/results?method=&quot;{name}&quot'
        'json': '/methods-map/json'
    }
    window["dataLayer"] = window["dataLayer"] or []
    window['srm']["methodsMap"]["dataLayer"] = window["dataLayer"]
    window['srm']["methodsMap"]["dataLayerTemplate0"] = {
            'event': 'module-load'
            'module': [
                {
                    'name': 'method-map'
                    'position': 'center'
                    'items': []  # NOTE: populated with window['srm']["methodsMap"]["dataLayerItemTemplate"] below
                }
            ]
        }
    window['srm']["methodsMap"]["dataLayerTemplate"] = {
            'event': 'module-select'
            'module': [
                {
                    'name': 'user-features'
                    'position': 'top-right'
                    'items': []  # NOTE: populated with window['srm']["methodsMap"]["dataLayerItemTemplate"] below
                }
            ]
        }
    window['srm']["methodsMap"]["dataLayerItemTemplate"] = {
        'type': 'UF'
        'action': 'mm-term'
        'name': 'concepts and philophies (610)'
        'position': '1'
    }

    return
